var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16699 8.33268C8.70675 8.33268 8.33366 8.70578 8.33366 9.16602V16.666C8.33366 17.1263 8.70675 17.4993 9.16699 17.4993H16.667C17.1272 17.4993 17.5003 17.1263 17.5003 16.666V9.16602C17.5003 8.70578 17.1272 8.33268 16.667 8.33268H9.16699ZM6.66699 9.16602C6.66699 7.7853 7.78628 6.66602 9.16699 6.66602H16.667C18.0477 6.66602 19.167 7.7853 19.167 9.16602V16.666C19.167 18.0467 18.0477 19.166 16.667 19.166H9.16699C7.78628 19.166 6.66699 18.0467 6.66699 16.666V9.16602Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33301 2.50065C3.11199 2.50065 2.90003 2.58845 2.74375 2.74473C2.58747 2.90101 2.49967 3.11297 2.49967 3.33398V10.834C2.49967 11.055 2.58747 11.267 2.74375 11.4232C2.90003 11.5795 3.11199 11.6673 3.33301 11.6673H4.16634C4.62658 11.6673 4.99967 12.0404 4.99967 12.5007C4.99967 12.9609 4.62658 13.334 4.16634 13.334H3.33301C2.66997 13.334 2.03408 13.0706 1.56524 12.6018C1.0964 12.1329 0.833008 11.497 0.833008 10.834V3.33398C0.833008 2.67094 1.0964 2.03506 1.56524 1.56622C2.03408 1.09738 2.66997 0.833984 3.33301 0.833984H10.833C11.496 0.833984 12.1319 1.09738 12.6008 1.56622C13.0696 2.03506 13.333 2.67094 13.333 3.33398V4.16732C13.333 4.62756 12.9599 5.00065 12.4997 5.00065C12.0394 5.00065 11.6663 4.62756 11.6663 4.16732V3.33398C11.6663 3.11297 11.5785 2.90101 11.4223 2.74473C11.266 2.58845 11.054 2.50065 10.833 2.50065H3.33301Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.faeaffd5.svg";
export { ForwardRef as ReactComponent };